import { type FC, memo, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import FilterIcon from 'assets/svg/futures/filter.svg'
import { Checkbox } from 'components/Checkbox'
import { FlexDiv } from 'components/layout/flex'
import { setOpenModal } from 'state/app/reducer'
import { selectUserInfoShowAllMarkets } from 'state/futures/common/selectors'
import { setPreferences } from 'state/futures/reducer'
import { useAppDispatch, useAppSelector } from 'state/hooks'

type TableFilterProps = {
	showFilters?: boolean
}

const TableFilters: FC<TableFilterProps> = memo(({ showFilters }) => {
	const { t } = useTranslation()
	const dispatch = useAppDispatch()

	const userInfoShowAllMarkets = useAppSelector(selectUserInfoShowAllMarkets)

	const handleToggleShowAllMarkets = useCallback(
		() => dispatch(setPreferences({ userInfoShowAllMarkets: !userInfoShowAllMarkets })),
		[dispatch, userInfoShowAllMarkets]
	)

	const handleOpenModal = useCallback(() => dispatch(setOpenModal('table_time_filter')), [dispatch])

	return (
		<Container>
			<Checkbox
				id="show-all-markets"
				onChange={handleToggleShowAllMarkets}
				checked={userInfoShowAllMarkets}
				label={t('futures.market.user.all-markets')}
				variant="simple"
			/>
			{showFilters && <FilterButton onClick={handleOpenModal} />}
		</Container>
	)
})

const Container = styled(FlexDiv)`
	margin: 12px 20px 0px 20px;
	padding-bottom: 12px;
	border-bottom: ${(props) => props.theme.colors.selectedTheme.border};
	display: flex;
	justify-content: space-between;
`

const FilterButton = styled(FilterIcon)`
	cursor: pointer;
`

export default TableFilters
